import * as THREE from 'three'
import AbstractEntity from '@/scripts/engine/AbstractEntity'
import Smoke from '@/scripts/engine/Smoke'
import PostFX from '@/scripts/engine/PostFX'

export default class World {
  constructor(options) {
    this.canvas = options.canvas;
    this.renderer = null;
    this.camera = null;
    this.cameraConfig = {
      fov: 75,
      aspect:  window.innerWidth / window.innerHeight,
      near: 1,
      far: 10000,
    };
    this.scene = null;
    this.entities = [];
    this.clock = new THREE.Clock();


    this.init();
    this.render();
    window.addEventListener('resize', this.onResize)
  }
  init() {
    const {canvas, cameraConfig, entities} = this;
    this.renderer = new THREE.WebGLRenderer({canvas, alpha:true});
    this.renderer.setSize(window.innerWidth, window.innerHeight);
    this.camera = new THREE.PerspectiveCamera(cameraConfig.fov, cameraConfig.aspect, cameraConfig.near, cameraConfig.far);
    this.camera.position.z = 5;

    this.scene = new THREE.Scene();

    this.FX = new PostFX(this.scene, this.camera, this.renderer);

    this.setupLights();

    // grid
    const gridSize = 9
    for (var i = -gridSize; i < gridSize; i++) {
      for (var j = -gridSize; j < gridSize; j++) {
        entities.push(new AbstractEntity(this.scene, {
          pos: {
            x: i * 0.5 * Math.random(),
            y: j * 0.6 * Math.random(),
            z: 0,
          },
          size: { width: 0.27 * Math.random(), height: 1, depth: 1 }
        }))
      }
    }
    this.smoke = new Smoke(this.scene);
    this.renderer.render(this.scene, this.camera);
  }
  setupLights() {
    const {scene} = this;
    var directionalLight = new THREE.DirectionalLight( 0xffffff, 0.125 );
				directionalLight.position.x = Math.random() - 0.5;
				directionalLight.position.y = Math.random() - 0.5;
				directionalLight.position.z = Math.random() - 0.5;
				directionalLight.position.normalize();
				scene.add(directionalLight);

        let pointLight = new THREE.PointLight(0xffffff, 3);
        scene.add(pointLight);
        // pointLight.add(new THREE.Mesh(new THREE.SphereBufferGeometry(4, 8, 8), new THREE.MeshBasicMaterial({color: 0xffffff})));
  }
  render = (time) => {
    const { entities } = this;
    let radius = 4.5
    entities.forEach((element, index) => {
      element.update(0.0002 * time + index * 0.03, radius)
    })
    time += 0.001
    this.smoke.update(time);
    // this.renderer.render(this.scene, this.camera);
    this.FX.composer.render(this.clock.getDelta());
    this.FX.update(time, {width: window.innerWidth, height: window.innerHeight});
    requestAnimationFrame(this.render)
  }
  onResize = () => {
    const {renderer, camera} = this;
    renderer.setSize(window.innerWidth, window.innerHeight);
    camera.aspect = window.innerWidth / window.innerHeight;
    camera.updateProjectionMatrix();
  }
}
